<nav class="navbar">
  <div class="navbar__container">
    <div class="navbrand d-flex align-items-center justify-content-center">
      <a class="brand" [routerLink]="">
        <img src="assets/img/logo.svg" alt="" />
      </a>
    </div>
  </div>
</nav>

<div
  class="container container--login"
  *ngIf="czyMoznaDodawacOswiadczenia && zaladowanoDane"
>
  <div class="ft__01 text-center py-4 mt-3">
    Oświadczenia {{ nazwaKlienta }}
  </div>
  <div class="text-center pb-4 mb-2">
    Wprowadź kod otrzymany na adres: {{ email }}
  </div>
  <form (ngSubmit)="potwierdz()">
    <div
      class="input_container pb-3"
      [ngClass]="czyBladWalidacyjny('kod') ? 'error' : ''"
    >
      <input placeholder="Kod" type="text" name="kod" [(ngModel)]="model.kod" />
      <div class="error-info fs__error pt-2" *ngIf="czyBladWalidacyjny('kod')">
        {{ pobierzBladWalidacyjny("kod") }}
      </div>
    </div>
    <div class="input_container pb-3">
      <button class="btn__primary">Potwierdź</button>
    </div>
    <p class="ft__04 my-2 pb-2 login_info">
      Kod nie dotarł?
      <a
        class="text-green"
        [routerLink]=""
        (click)="wyslijKodPonownie()"
        style="cursor: pointer"
        >Wyślij kod ponownie.
      </a>
    </p>
    <hr />
  </form>
</div>
<div
  class="container container--login"
  *ngIf="!czyMoznaDodawacOswiadczenia && zaladowanoDane"
>
  <div class="ft__01 text-center py-4 mt-3">
    Wypełnianie oświadczeń nie jest możliwe
  </div>
</div>
